import { StyledPageHeader } from './style';

export const PageHeader = (props) => {
  return <StyledPageHeader {...props} />;
}
